import { Header } from "../components/Header";
import { SideBar } from "../components/SideBar";
import { Router } from "../routes/routes";
import { useAuth } from "../context/AuthContext";

export function MainPage() {
  const { isAuthenticated } = useAuth();

  const versao = '2.0.14'

  return (
    <div>
      {/* header section */}
      <section>
        <div>
          <Header />
        </div>
      </section>
      {/* sidebar section */}
      <section className="bg-[#f1f5f9]  ">
        <div className="flex items-center  overflow-hidden  ">
          <div className=" ">{isAuthenticated && <SideBar versao={versao} />}</div>
          <div className="h-page w-full">
            <Router versao={versao} />
          </div>
        </div>
      </section>
    </div>
  );
}
